import { render } from "./EditLimits.vue?vue&type=template&id=26256403"
import script from "./EditLimits.vue?vue&type=script&lang=js"
export * from "./EditLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__